export default __webpack_public_path__ + "d01551a0b4046fca5aecde95dfa941f1.svg";